import React from "react";
import { JWT } from "../shared";
import { AuthService } from "../services";
import { UserRoleType } from "../constants/Enum";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { routes } from "../constants/routes";

const PrivateRoutes = () => {
  const isValidToken = JWT.isValidToken();
  const loginUser = AuthService.getLoginUser();
  const location = useLocation();

  const isAuthorised = () => {
    if (!isValidToken && !loginUser && location?.pathname) {
      localStorage.setItem("loginUrl", location?.pathname);
    }
    return isValidToken && loginUser;
  };

  return isAuthorised() ? (
    loginUser && loginUser?.role === UserRoleType.UNKNOWN ? (
      <Navigate to={routes.ADMIN_DASHBOARD} />
    ) : (
      <Outlet />
    )
  ) : location.pathname.startsWith("/admin") ? (
    <Navigate to={routes.ADMIN_LOGIN} />
  ) : (
    <Navigate to={routes.DEFAULT} />
  );
};

export default PrivateRoutes;
